import React from 'react';

interface ScrollableListProps {
  children: React.ReactNode;
  emptyMessage?: string;
  viewportHeightPercentage?: number;
  className?: string;
}

export function ScrollableList({
  children,
  emptyMessage = 'No items to display',
  viewportHeightPercentage = 50,
  className = '',
}: ScrollableListProps) {
  const hasItems = React.Children.count(children) > 0;

  return (
    <div
      className={`d-flex flex-column flex-grow-1 overflow-auto w-100 ${className}`}
      style={{ height: `${viewportHeightPercentage}vh` }}
    >
      {!hasItems ? (
        <div className="text-center text-muted p-4 bg-neutral-800 rounded">
          {emptyMessage}
        </div>
      ) : (
        children
      )}
    </div>
  );
}
